import { translate } from '@repo/phrase';
import { Paragraph } from '@repo/ui/typography';

import styles from './styles.module.scss';

export const AssetsEmpty = () => {
    return (
        <div data-testid="assets-empty" className={styles.assets_empty} role="alert">
            <Paragraph>{translate('assets_no_results')}</Paragraph>
        </div>
    );
};
